document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".scientific-reference");
  const metafieldContent = section?.querySelector(".m-richtext__description");

  // Check if metafield content is empty or only whitespace
  const isEmpty = !metafieldContent || metafieldContent.textContent.trim() === "";

  if (isEmpty) {
    section.style.display = "none";
  }

});

document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".m-collapsible");

  faqItems.forEach(item => {
    const content = item.querySelector(".m-collapsible--content .rte");

    // Check if content is missing or just whitespace
    if (!content || content.textContent.trim() === "") {
      item.style.display = "none";
    }
  });
});






